import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { SkipFinanceService } from '@app/configure/services/skip-finance.service';
import { ConfigureService } from '@app/configure/services/configure.service';
import { ModalService } from '@app/core/services/modal.service';

import { FinanceQuote } from '@app/core/models/finance-quote.model';
import { ModalAction } from '@app/core/models/modal-action.model';
import { Modal } from '@app/core/models/modal.model';

@Component({
	selector: 'cng-full-breakdown',
	templateUrl: './full-breakdown.component.html',
	styleUrls: ['./full-breakdown.component.less'],
})
export class ConfigureFullBreakdownComponent implements OnInit, OnDestroy {
	modalData: any = this.modal_service.data;
	quote: FinanceQuote;
	configure_data: any = this.configure_service.configure_data;
	destroyed$: Subject<boolean> = new Subject<boolean>();
	options: any = [];
	depositTabActive: boolean = this.modalData.tabToShow === 'deposit';
	financeTabActive: boolean = this.modalData.tabToShow === 'finance';
	vehicle: any = this.configure_service.configure_data.steps.purchase_vehicle.data;
	part_exchanges: any = this.configure_data.steps.part_exchange.data.filter((pex: any) => {
		return pex.vehicle !== null;
	});

	grand_total_vat: number = this.configure_service.configure_data.steps.customise_review.data.grand_total_vat;

	tabs: any[] = [
		{
			name: 'Deposit',
			route: 'deposit',
		},
		{
			name: 'Finance',
			route: 'finance',
		},
	];

	constructor(
		private modal_service: ModalService,
		private configure_service: ConfigureService,
		private skip_finance_service: SkipFinanceService
	) {
		this.constructModal();
		this.options = this.getNonFinanceableAddons();
		this.getSelectedFinance();
	}

	constructModal(): void {
		this.modal_service.setConfig(
			new Modal({
				name: 'full_breakdown_modal',
				title: 'Full Breakdown',
				height: 'full',
				actions: [
					new ModalAction({
						id: 'reserve',
						name: 'Reserve Now',
						bias: 'positive',
						large: true,
						click: async () => {
							await this.modal_service.close();

							// this.skip_finance_service.onJumpSteps('reserve', (canProceed: boolean) => {
							// 	if (canProceed) {
							this.configure_service.navigateToStep('reserve');
							// }
							// });
						},
					}),
				],
			})
		);
	}

	ngOnInit(): void {
		this.configure_service.configure_data$.pipe(takeUntil(this.destroyed$)).subscribe((configure_data) => {
			this.configure_data = configure_data;
			this.part_exchanges = configure_data.steps.part_exchange.data.filter((pex: any) => {
				return pex.vehicle !== null;
			});
		});
	}

	changeTab(index: number): void {
		if (index === 0) {
			this.depositTabActive = true;
			this.financeTabActive = false;
			return;
		}

		this.depositTabActive = false;
		this.financeTabActive = true;
	}

	getSelectedFinance(): any {
		this.quote = this.configure_data.steps.finance_options.data.find((quote) => {
			return quote.selected;
		});
	}

	getNonFinanceableAddons(): any {
		return this.configure_service.getSelectedAddons().filter((option) => {
			return !option.financeable && option.amount > 0;
		});
	}

	getVatableAddons(): any {
		return this.configure_service.getVatableAddons();
	}

	getSelectedQuote(): any {
		return this.configure_service.getSelectedQuote();
	}

	calculateCashDeposit(): number {
		return this.configure_service.getTotalCashDeposit();
	}

	getTotalVatDeposit(): number {
		let vatDeposit = this.configure_service.configure_data.steps.customise_review.data.grand_total_vat;
		const addons = this.getVatableAddons();

		addons.forEach((addon) => {
			vatDeposit -= addon.amount - addon.net_amount;
		});

		return vatDeposit;
	}

	getTotalDeposit(): number {
		return this.configure_service.getTotalDeposit();
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
	}
}
